import { useFinanceGraphProductionQuery } from "@/api/graphql"
import { useProductionGraphContext } from "@/components/graphs/types/bar/ProductionGraphContext"
import { useCurrentFinanceProjectId } from "../hooks/useCurrentFinanceProjectId"

export function useFinanceGraphProductionData() {
	const id = useCurrentFinanceProjectId()
	const { graphInterval, startTime, endTime, knmiDataStatus } =
		useProductionGraphContext()

	// Query Finance Graph Production
	return useFinanceGraphProductionQuery({
		startTime,
		endTime,
		interval: graphInterval,
		id: String(id),
		knmiDataIncluded: knmiDataStatus === "included",
	})
}
